/*
 * @Author: JamesWong
 * @Description: 自助收银中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-12-03 16:05:06
 */
export default {
  authorizedDevice: '授权设备',
  remainDevices: '剩余可用授权设备数',
  order: '序号',
  authorizationTime: '授权时间',
  machineNumber: '机器编码',
  machineCode: '设备机器码',
  operate: '操作',
  cancelAuthorization: '取消授权',
  cancelAuthorizeDevice: '取消授权设备',
  cancelAuthorizationTips: '确定取消授权设备',
  cancel: '取消',
  confirm: '确定',
  rollingPhotos: '轮播图片',
  uploadPhotosTips: '图片比例16：9，大小不超过5M',
  upload: '上传',
  previewPhotos: '预览图片',
  delete: '删除',
  deleted: '删除成功',
  createQRcode: '开卡二维码',
  uploadQRcodeTips: '图片比例1：1，大小不超过1M',
  uploadingTips: '文件正在上传中...  请稍等',
  uploadProgress: '上传进度',
  Unnamed: '未命名',
  photoUploaded: '上传图片成功！',
  phoneSizeTips: '文件大小不能超过1M！',
  phoneSizeTips5: '文件大小不能超过5M！',
  longNameTips: '文件名不能过长！',
  noPhotoTips: '你还没有上传图片，赶快上传吧',
  deletedError: '删除失败!',
  cancelAuthorized: '取消授权成功！'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/self.js